import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Style-guide" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="nifty-UI-guide" transform="translate(-202.000000, -3291.000000)" fill={color}>
                <g id="Group-6" transform="translate(159.000000, 3248.000000)">
                    <path d="M77.0002927,63 C78.1047006,63 79,63.8945138 79,64.9940603 L79,77.0059397 C79,78.1072288 78.1101074,79 77.0002927,79 L44.9997073,79 C43.8952994,79 43,78.1054862 43,77.0059397 L43,64.9940603 C43,63.8927712 43.8898926,63 44.9997073,63 L77.0002927,63 Z M75,67 L47,67 L47,75 L75,75 L75,67 Z M77.0002927,43 C78.1047006,43 79,43.8945138 79,44.9940603 L79,57.0059397 C79,58.1072288 78.1101074,59 77.0002927,59 L44.9997073,59 C43.8952994,59 43,58.1054862 43,57.0059397 L43,44.9940603 C43,43.8927712 43.8898926,43 44.9997073,43 L77.0002927,43 Z M75,47 L47,47 L47,55 L75,55 L75,47 Z" id="Rectangle-560"></path>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconList extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
